import { render, staticRenderFns } from "./CmgCheckoutAddressInfo.vue?vue&type=template&id=18bcc41b&scoped=true&lang=pug"
import script from "./cmg-checkout-address-info.ts?vue&type=script&lang=ts&external"
export * from "./cmg-checkout-address-info.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgCheckoutAddressInfo.vue?vue&type=style&index=0&id=18bcc41b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bcc41b",
  null
  
)

export default component.exports